import { jsx as _jsx } from "react/jsx-runtime";
import { Avatar } from '@mui/material';
export default (props) => (
// eslint-disable-next-line react/jsx-props-no-spreading
_jsx(Avatar, { sx: {
        backgroundColor: 'transparent',
        border: (theme) => `2.5px solid ${theme.palette.primary.light}`,
        // eslint-disable-next-line react/destructuring-assignment
        width: props.width,
        // eslint-disable-next-line react/destructuring-assignment
        height: props.height,
        padding: (theme) => theme.spacing(0.75),
        color: (theme) => theme.palette.tertiary.main,
    }, children: _jsx("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", enableBackground: "new 0 0 24 24", id: "Layer_1", viewBox: "0 0 24 24", xmlSpace: "preserve", width: "1em", height: "1em", ...props, children: _jsx("line", { fill: "currentColor", stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 4, x1: 5, x2: 19, y1: 12, y2: 12 }) }) }));
//# sourceMappingURL=MinusCircleIcon.js.map